export default class plainContent {
    constructor() {
        return {
            template: require('../../../../views/maileditor/plain-content.html'),
            replace: true,
            restrict: 'E',
            controller: PlainContentCtrl,
            controllerAs: 'textEditor'
        }
    }
};

let textHeaders = {
    'Content-Type': 'text/plain',
    'accept': 'text/plain'
};

class PlainContentCtrl {
    constructor($scope, Campaign, Automation, Rest) {
        this._scope = $scope;

        this.campaignRepo = Campaign;
        this.automationRepo = Automation;
        this.rest = Rest.rest;

        this._scope.$on('mailEditor:state:init', (event, data) => {
            this.dispatcher = data['dispatcher'];
            this.dispatcherType = data['dispatcherType'];
            this.source = data['plainSource'];

            this.fetchContent();
        });

        this._scope.$on('plainContent:fetchHistoricalVersion', (event, src) => {
            this.rest.one(src).customGET('', {}, textHeaders).then((content) => {
                this.content = content;
            })
        });

        this._scope.$on('plainEditor:getContent', (event, callback) => {
            return callback(this.content);
        });
    }

    fetchContent() {
        this.rest.one(this.source).customGET('', {'type': 'text/plain'}, textHeaders)
            .then((content) => {
            this.content = content;
        });
    }
}
